import { combineReducers } from 'redux';
import reducerMain from './reducerMain';
import rootReducer from './rootReducer';
import reducerSvcs from 'store/reducers/reducerSvcs';
import reducerToast from 'store/reducers/reducerToast';
import reducerWeather from 'store/reducers/reducerWeather';
import reducerTrend from 'store/reducers/reducerTrend';

export interface IfReduxRoot {
  root;
  main;
  svcs;
  toast;
  trend;
  weather;
}

const reducers = combineReducers<IfReduxRoot>({
  root: rootReducer,
  main: reducerMain,
  svcs: reducerSvcs,
  toast: reducerToast,
  trend: reducerTrend,
  weather: reducerWeather,
});

export default reducers;
